import { TrendingDown, TrendingUp } from "lucide-react";

export interface MetricStripItem {
  label: string;
  value: string;
  unit?: string;
  delta?: { direction: "up" | "down"; label: string };
}

/** Dense row of labeled metrics with optional trend deltas. */
export function MetricStrip({ items }: { items: readonly MetricStripItem[] }) {
  return (
    <dl className="metric-strip">
      {items.map((item) => (
        <div className="metric-strip-item" key={item.label}>
          <dt className="metric-strip-label">{item.label}</dt>
          <dd className="metric-strip-value">
            <span className="metric-value">{item.value}</span>
            {item.unit ? <span className="metric-strip-unit">{item.unit}</span> : null}
            {item.delta ? (
              <span className={`metric-strip-delta metric-strip-delta--${item.delta.direction}`}>
                {item.delta.direction === "up" ? (
                  <TrendingUp size={14} strokeWidth={1.5} absoluteStrokeWidth aria-hidden="true" />
                ) : (
                  <TrendingDown
                    size={14}
                    strokeWidth={1.5}
                    absoluteStrokeWidth
                    aria-hidden="true"
                  />
                )}
                {item.delta.label}
              </span>
            ) : null}
          </dd>
        </div>
      ))}
    </dl>
  );
}
